module.exports = __webpack_public_path__ + "img/vls_varialandstk.fb0b660.png";